import {Flex, Stack, Text} from '@chakra-ui/react'
import React from 'react'
import {FormattedMessage, FormattedNumber} from 'react-intl'
import PromoPopover from '../promo-popover'
import {useOrderSummary} from './order-summary-provider'
import {useCurrentCustomer} from '../../hooks/use-current-customer'

const OrderSummaryShipping = () => {
    const basket = useOrderSummary()
    const {isCustomNetPriceEnabled} = useCurrentCustomer().data

    const shippingItem = basket.shippingItems?.[0]
    const hasShippingPromos = shippingItem?.priceAdjustments?.length > 0

    const header = (
        <FormattedMessage defaultMessage="Promotion" id="order_summary.promo_popover.heading" />
    )

    return (
        <Flex justify="space-between" gap={6} minWidth="100%">
            <Flex alignItems="center">
                <Flex
                    flexDirection="row"
                    gap={2}
                    data-testid="sf-order-summary-shipping-price_text"
                >
                    <Text>
                        <FormattedMessage
                            defaultMessage="Shipping"
                            id="order_summary.label.shipping"
                        />
                    </Text>
                    {isCustomNetPriceEnabled && (
                        <Text color="stokkeGray.accessibleText">
                            <FormattedMessage
                                id="global.taxes_not_included"
                                defaultMessage="tax not included"
                            />
                        </Text>
                    )}
                </Flex>
                {hasShippingPromos && (
                    <PromoPopover header={header} mx={1.5}>
                        <Stack>
                            {shippingItem?.priceAdjustments?.map((adjustment) => (
                                <Text key={adjustment.priceAdjustmentId}>
                                    {adjustment.itemText}
                                </Text>
                            ))}
                        </Stack>
                    </PromoPopover>
                )}
            </Flex>

            {shippingItem?.priceAdjustments?.some(
                ({appliedDiscount}) => appliedDiscount?.type === 'free'
            ) || basket.shippingTotal === 0 ? (
                <Text
                    as="span"
                    color="stokkeFunctional.alertGreen"
                    textTransform="uppercase"
                    data-testid="sf-order-summary-shipping-price"
                >
                    <FormattedMessage defaultMessage="Free" id="global.free" />
                </Text>
            ) : (
                <Text data-testid="sf-order-summary-shipping-price">
                    <FormattedNumber
                        value={
                            !isCustomNetPriceEnabled
                                ? basket.shippingTotal
                                : basket.c_shippingTotalNetPrice
                        }
                        style="currency"
                        currency={basket.currency}
                    />
                </Text>
            )}
        </Flex>
    )
}

export default OrderSummaryShipping
